import { getTenantFromBrowser } from '@/utils/tenant.js';
import { getStoredToken } from '@/utils/authStorage.js';

function readJsonStorage(key) {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function resolveTenantHeaderValue() {
  const tenant = readJsonStorage('tenant');
  const candidates = [
    tenant?.dominio,
    tenant?.domain,
    tenant?.code,
    tenant?.codigo,
    typeof tenant === 'string' ? tenant : null,
    getTenantFromBrowser(),
  ];

  const selected = candidates.find((value) => typeof value === 'string' && value.trim());
  return selected ? selected.trim() : '';
}

export function resolveEmpresaId() {
  const tenant = readJsonStorage('tenant');
  const user = readJsonStorage('user');
  const candidates = [
    tenant?.id,
    tenant?.empresa_id,
    tenant?.empresaId,
    tenant?.empresa?.id,
    user?.empresa_id,
    user?.empresaId,
    user?.empresa?.id,
    user?.sucursalActiva?.empresa_id,
    user?.sucursalActiva?.empresaId,
    user?.sucursal?.empresa_id,
    user?.sucursal?.empresaId,
  ];

  const selected = candidates.find((value) => value !== null && value !== undefined && value !== '');
  return selected ?? null;
}

export function resolveSucursalActivaId() {
  const user = readJsonStorage('user');
  const candidates = [
    user?.sucursal_activa_id,
    user?.sucursalActiva?.id,
    user?.sucursal?.id,
    user?.sucursal_id,
    user?.sucursalPrincipal?.id,
    user?.sucursal_principal_id,
  ];
  const selected = candidates.find((value) => value !== null && value !== undefined && value !== '');
  return selected ?? null;
}

export function resolveAuthenticatedHeaders(extraHeaders = {}) {
  const headers = { ...extraHeaders };
  const token = getStoredToken();
  const tenantHeader = resolveTenantHeaderValue();
  const empresaId = resolveEmpresaId();
  const sucursalId = resolveSucursalActivaId();
  const user = readJsonStorage('user');

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (tenantHeader) {
    headers['X-Tenant'] = tenantHeader;
  }
  if (empresaId) {
    headers['X-Empresa-Id'] = empresaId;
  }
  if (sucursalId) {
    headers['X-Sucursal-Id'] = sucursalId;
  }
  if (user?.id) {
    headers['X-User-Id'] = user.id;
  }

  return headers;
}
